// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6084) return "static/chunks/4e6af11a-4115d40596e16744.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9066 ? "dc112a36" : chunkId) + "." + {"1138":"096fed24ac8b828a","1530":"7ee787d5989d200b","6223":"c51e99a62ce201ac","9066":"54cf0bbe503467d8"}[chunkId] + ".js";
};